//initialize 16/16 board

import Tile from './Tile'
import { boardData } from './BoardData'

function createEmptyBoard(length){
  var board = [];
  for(var i = 0; i < length; i++){
    board.push([])
  }
  return board;
}

function rotateSymbol(symbol, times){
  if(symbol.length < 2) return symbol;
  var isDestination = false,
      rotation = {
        'l-': '-l',
        '-l': '_l',
        '_l': 'l_',
        'l_': 'l-',
        ' l': '_',
        '_': 'l ',
        'l ': '-',
        '-': ' l'
      }
  if(symbol[0] === '*'){
    isDestination = true;
  }
  symbol = symbol.replace('*', '');
  for(var i = 0; i < times; i++){
    symbol = rotation[symbol]
  }
  if(isDestination) return '*' + symbol;
  return symbol
}

function rotateToBottomRight(board){
  var newBoard = createEmptyBoard(8),
      length = board.length;
  for(var row = length - 1; row >= 0; row--){
    for(var col = length - 1; col >= 0; col--){
      newBoard[length-row-1].push(rotateSymbol(board[row][col], 2))
    }
  }
  return newBoard;
}

function rotateToTopRight(board){
  var newBoard = createEmptyBoard(8),
      length = board.length;
  for(var row = length - 1; row >= 0; row--){
    for(var col = 0; col < length; col++){
      newBoard[col].push(rotateSymbol(board[row][col], 1))
    }
  }
  return newBoard;
}

function rotateToBottomLeft(board){
  var newBoard = createEmptyBoard(8),
      length = board.length;
  for(var row = 0; row < length; row++){
    for(var col = length - 1; col >= 0; col--){
      newBoard[length-col-1].push(rotateSymbol(board[row][col], 3))
    }
  }
  return newBoard;
}

function combineBoards(first, second, third, fourth){
  var finalBoard = [];
  first.forEach(function(row, index){
    finalBoard.push(row.concat(second[index]))
  })
  third.forEach(function(row, index){
    finalBoard.push(row.concat(fourth[index]))
  })
  return makeThickBorder(finalBoard)
}

function makeThickBorder(board){
  board.forEach(function(row, rowIndex){
    row.forEach(function(tile, colIndex){
      if(tile){
        if(tile.leftWall && colIndex) board[rowIndex][colIndex-1].rightWall = true
        if(tile.rightWall && colIndex !== 15) board[rowIndex][colIndex+1].leftWall = true
        if(tile.downWall && rowIndex !== 15) board[rowIndex+1][colIndex].upWall = true
        if(tile.upWall && rowIndex) board[rowIndex-1][colIndex].downWall = true
      }
    })
  })
  return board;
}

function _assignPosition(rowIndex,colIndex) {
  var position = '',
      isCenter = (rowIndex === 7 || rowIndex === 8) && (colIndex === 7 || colIndex === 8)
  if(rowIndex === 0 || isCenter) position = position + "top ";
  if(rowIndex === 15 || isCenter) position = position + "bottom ";
  if(colIndex === 0 || isCenter) position = position + "left ";
  if(colIndex === 15 || isCenter) position = position + "right ";
  return position;
}

//have api to be assigned walls
//when robots move around they check to see if collision occur, if they do then robots stop

export default class Board {
  constructor(config){
    this.goals = []
    //save this configuration
    this.config = config
    this.board = this.newBoard(config)
  }
  getBoardData(config){
    var colorNum = typeof config[0] === 'number' ? config[0] : Math.floor(Math.random()*4),
        boardNum = typeof config[1] === 'number' ? config[1] : Math.floor(Math.random()*3)
    return boardData[colorNum][boardNum]
  }
  generateboard(config){
    var first = this.getBoardData(config[0]);
    var second = rotateToTopRight(this.getBoardData(config[1]));
    var third = rotateToBottomLeft(this.getBoardData(config[2]));
    var fourth = rotateToBottomRight(this.getBoardData(config[3]));
    return combineBoards(first, second, third, fourth);
  }
  getGoals(){
    return this.goals.slice();
  }
  //break string into tuples
  parseBoardConfig(string){
    var config = [[],[],[],[]];
    if(typeof string !== 'string'){
      string = this.generateRandomBoardConfig(config)
    }
    string.split("").forEach(function(character, index){
      config[Math.floor(index/2)].push(Number(character))
    })
    return config;
  }
  generateRandomBoardConfig(config){
    var configString = ""
    config.forEach(function(arr){
      let colorNum = Math.floor(Math.random()*4),
          boardNum = Math.floor(Math.random()*3);
      arr = [colorNum, boardNum]
      configString += colorNum
      configString += boardNum
    })
    this.config = configString
    return configString
  }
  newBoard(boardConfig){
    var config = this.parseBoardConfig(boardConfig),
        board = this.generateboard(config);
    return makeThickBorder(board.map(function(tiles, rowIndex){
      return tiles.map(function(symbol, colIndex){
        if(symbol[0] === '*'){
          this.goals.push([rowIndex, colIndex])
          symbol = symbol.replace('*','')
        }
        var position = _assignPosition(rowIndex, colIndex);
        return new Tile(symbol, position);
      }.bind(this))
    }.bind(this)))
  };
};


// WEBPACK FOOTER //
// ./game/Board.js